import React from 'react';
import { acceptanceCreationSteps } from '../../../../model';
import AddressesSetup from './AddressesSetup';
import AcceptanceSetup from './AcceptanceSetup';

const headers = {
  [acceptanceCreationSteps.addressesSetup]: AddressesSetup,
  [acceptanceCreationSteps.acceptanceSetup]: AcceptanceSetup,
};

const Header = ({ step }) => {
  const Component = headers[step];
  return <Component />;
};

export default Header;
